import SidebarBookingsSummaryRoute from 'uplisting-frontend/pods/-sidebar/bookings/summary/route';

export default abstract class ActionBookingsSummaryRoute extends SidebarBookingsSummaryRoute {
  parentRoute = 'action.bookings';
}
